import styled from 'styled-components'

const Content = styled.div`
  flex: 1;
  background-color: white;
  text-align: center;
  overflow: auto;
`

export default Content;
